import { render } from "./OrderQueriesHistory.vue?vue&type=template&id=d6153214&scoped=true"
import script from "./OrderQueriesHistory.vue?vue&type=script&lang=js"
export * from "./OrderQueriesHistory.vue?vue&type=script&lang=js"

import "./OrderQueriesHistory.vue?vue&type=style&index=0&id=d6153214&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6153214"]])

export default __exports__